import React from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import {
  kindergartenApplicationsListTable,
  KindergartenApplicationState,
} from "../../../shared/tableObjects/kindergarten/kindergartenApplicationListTable";
import { useAccount, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router";
import { Button } from "primereact/button";

export default function KindergartenApplicationsListPending() {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const apiClient = useApiClient("InvitedApplications");

  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "List of Applications Pending Submission",
      icon: "list-icon icon-spec",
    },
  ];

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <Button
          label="Create Application"
          onClick={() => navigate("/kindergarten/screening")}
          autoFocus
          icon="pi pi-plus-circle text-2xl"
          className="float-right filled-round-button"
        />
        <Table
          apiClient={apiClient}
          label={""}
          columns={kindergartenApplicationsListTable("/kindergarten/pendingApplications", KindergartenApplicationState.pending)}
          route={`allMyInvited/pending/${account?.idTokenClaims?.["extension_ApplicationIds"]}`}
        />
      </div>
    </>
  );
}
